import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="covid-test-claim-submissions"
export default class extends Controller {
  static targets = [
    "hasInsuranceTrue", 
    "hasInsuranceFalse", 
    "insurerNameContainer", 
    "noInsurerMessageContainer", 
    "hasOtherInsuranceTrue", 
    "hasOtherInsuranceFalse", 
    "secondaryInsuranceMessageContainer", 
    "insurerId", 
    "insurerName",
    "governmentInsuranceMessageContainer", 
    "otherInsuranceMessageContainer", 
    "submitButton", 
    "firstName"
  ]

  connect() {
    // Run all the change methods here in order to force the right visibility when the 
    // page first loads.  This mostly matters if the user clicks the back button and 
    // some fields are already set.
    this.changeInsurance();
    this.toggleOtherInsuranceWarning();
    this.changeInsurer();

    // Also make sure the Continue button has the correct enabled/disabled state.
    // But we have to add a slight delay so the corresponding elements get a chance to 
    // adopt their new state;
    setTimeout(() => {
      this.validateForm();
    }, 1);
  }

  changeInsurance() {
    if (this.hasInsuranceTrueTarget.checked) {
      this.insurerNameContainerTarget.style.display = "block"
      this.noInsurerMessageContainerTarget.style.display = "none"
    } else if (this.hasInsuranceFalseTarget.checked) {
      this.insurerNameContainerTarget.style.display = "none"
      this.noInsurerMessageContainerTarget.style.display = "block"
    }
  }

  toggleOtherInsuranceWarning() {
    if (this.hasOtherInsuranceTrueTarget.checked) {
      this.secondaryInsuranceMessageContainerTarget.style.display = "block"
    } else if (this.hasOtherInsuranceFalseTarget.checked) {
      this.secondaryInsuranceMessageContainerTarget.style.display = "none"
    }
  }

  changeInsurer() {
    var insurerName = this.insurerNameTarget.value;

    if (insurerName === "Other") {
      this.otherInsuranceMessageContainerTarget.style.display = "block"
      this.governmentInsuranceMessageContainerTarget.style.display = "none"
    } else if (["Medicare", "Medicare Advantage", "Medicaid"].includes(insurerName)) {
      this.governmentInsuranceMessageContainerTarget.style.display = "block"
      this.otherInsuranceMessageContainerTarget.style.display = "none"
    } else {
      this.otherInsuranceMessageContainerTarget.style.display = "none"
      this.governmentInsuranceMessageContainerTarget.style.display = "none"
    }
  }

  validateForm() {
    var insurerName = this.insurerNameTarget.value;

    if (
      this.firstNameTarget.value.length > 0
      && this.hasInsuranceTrueTarget.checked
      && this.hasOtherInsuranceFalseTarget.checked
      && this.insurerIdTarget.value.length > 0
      && !["Medicare", "Medicare Advantage", "Medicaid"].includes(insurerName)
    ) {
      this.submitButtonTarget.disabled = false
    } else {
      this.submitButtonTarget.disabled = true
    }
  }
}
